import React, { useState } from 'react';
import '../../styles/eventModal.scss'; // Asegúrate de crear un archivo CSS con los estilos adecuados.
import Modal from '../Layout/Modal';
import SuccessModal from './SuccessModal';
import EventForm from '../Calendar/Form/EventForm';
import ErrorModal from './ErrorModal';

const EventModal = ({ eventDetails }) => {
  const { eventType, date, hour } = eventDetails;
  const [seller, setSeller] = useState('');
  const [refNumber, setRefNumber] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [errorTitleMessage, setErrorTitleMessage] = useState('');

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(false);

  return (
    <Modal className={'event-modal-overlay'}>
      <div className="event-modal-content">
        {!isSubmitted && (
          <EventForm
            eventDetails={eventDetails}
            setSeller={setSeller}
            setRefNumber={setRefNumber}
            setErrorMessage={setErrorMessage}
            setIsSubmitSuccessful={setIsSubmitSuccessful}
            setIsSubmitted={setIsSubmitted}
            setErrorTitleMessage={setErrorTitleMessage}
          />
        )}
        {isSubmitted && isSubmitSuccessful && (<SuccessModal refNumber={refNumber} seller={seller} appointmentType={eventType} date={date} hour={hour} />)}
        {isSubmitted && !isSubmitSuccessful && (<ErrorModal errorMsg={errorMessage} errorTitleMessage={errorTitleMessage} />)}
      </div>
    </Modal>
  );
};

export default EventModal;
